import { Box, Tab, Tabs } from "@mui/material";
import ServerDataTableAdapter from "../../../../shared/management/table/adapters/ServerDataTableAdapter";

export function QuickBooksOverviewTab({
  columns,
  tabData,
  rowsPerPage,
  sortConfig,
  onSortChange,
  selectedRows,
  onSelectedRowsChange,
  onFiltersChange,
  onDeleteRequest,
  renderCellContent,
  renderRowActionsMenu,
  renderSelectionToolbar,
}) {
  return (
    <ServerDataTableAdapter
      columns={columns}
      rows={tabData.data}
      onDeleteRequest={onDeleteRequest}
      emptyMessage="No QuickBooks accounts found"
      loading={tabData.loading}
      error={tabData.error}
      searchTerm={tabData.searchTerm}
      page={tabData.page}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={() => {}}
      hasNextPage={!!tabData.nextCursor}
      hasPrevPage={!!tabData.prevCursor}
      onNextPage={tabData.handleNextPage}
      onPreviousPage={tabData.handlePreviousPage}
      onFiltersChange={onFiltersChange}
      onSortChange={onSortChange}
      sortConfig={sortConfig}
      selectedRows={selectedRows}
      onSelectedRowsChange={onSelectedRowsChange}
      renderCellContent={renderCellContent}
      renderRowActionsMenu={renderRowActionsMenu}
      renderSelectionToolbar={renderSelectionToolbar}
      filterPopoverByField={{}}
    />
  );
}

export function QuickBooksSyncHistoryTab() {
  return (
    <Box sx={{ p: 3 }}>
      <div>Sync History Tab - Coming Soon</div>
    </Box>
  );
}

export function QuickBooksErrorsTab() {
  return (
    <Box sx={{ p: 3 }}>
      <div>Errors Tab - Coming Soon</div>
    </Box>
  );
}

export default function QuickBooksTabContainer({
  columns,
  activeSubTab,
  tabData,
  rowsPerPage,
  sortConfig,
  onSortChange,
  onSubTabChange,
  selectedRows,
  onSelectedRowsChange,
  onFiltersChange,
  onDeleteRequest,
  renderErrorsContent,
  renderCellContent,
  renderRowActionsMenu,
  renderSyncHistoryContent,
  renderSelectionToolbar,
}) {
  return (
    <Box>
      <Tabs
        value={activeSubTab}
        onChange={onSubTabChange}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
      >
        <Tab label="Overview" value="overview" />
        <Tab label="Sync History" value="sync-history" />
        <Tab label="Errors" value="errors" />
      </Tabs>

      {activeSubTab === "overview" && (
        <QuickBooksOverviewTab
          columns={columns}
          tabData={tabData}
          rowsPerPage={rowsPerPage}
          sortConfig={sortConfig}
          onSortChange={onSortChange}
          selectedRows={selectedRows}
          onSelectedRowsChange={onSelectedRowsChange}
          onFiltersChange={onFiltersChange}
          onDeleteRequest={onDeleteRequest}
          renderCellContent={renderCellContent}
          renderRowActionsMenu={renderRowActionsMenu}
          renderSelectionToolbar={renderSelectionToolbar}
        />
      )}

      {activeSubTab === "sync-history" && (
        renderSyncHistoryContent?.() || <QuickBooksSyncHistoryTab />
      )}

      {activeSubTab === "errors" && (
        renderErrorsContent?.() || <QuickBooksErrorsTab />
      )}
    </Box>
  );
}
